'use client'

import { isbot } from 'isbot'

export default function getIsCrawler(): boolean {
  return typeof window !== 'undefined'
    ? isbot(window.navigator.userAgent)
    : false
}
